import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntityProfile from 'components/organisms/Profiles/EntityProfile/EntityProfile';

const StyledDatabaseEntityProfile = styled(EntityProfile)`
  ${ComponentStyles}
`;

StyledDatabaseEntityProfile.propTypes = {
  theme: PropTypes.object
};

export default StyledDatabaseEntityProfile;
